// relative
import { subscriptionManagerApiSlice } from '../apiSlice';

export const stateCodeApiSlice = subscriptionManagerApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOccupancyPrediction: builder.query({
      query: (args) => {
        const { jobSubscriptionId, start, end } = args;
        return {
          url: `/occupancy_prediction/${jobSubscriptionId}?start_time=${start}&end_time=${end}`,
        };
      },
      providesTags: ['OccupancyPrediction'],
    }),

    getOccupancyPredictionAnalysis: builder.query({
      query: ({
        jobSubscriptionId,
        duration,
        filterErraticPredictions = 'true',
        exclusions,
      }) => {
        let url = `/occupancy_prediction/${jobSubscriptionId}`;

        if (
          filterErraticPredictions !== undefined &&
          filterErraticPredictions !== null
        ) {
          url += `?filter_erratic_predictions=${filterErraticPredictions}`;
        }

        if (duration !== undefined && duration !== null && duration !== '') {
          url +=
            (url.includes('?') ? '&' : '?') +
            `minimum_occupancy_duration=${duration}`;
        }

        if (
          exclusions !== undefined &&
          exclusions !== null &&
          exclusions.length > 0
        ) {
          exclusions.forEach((exclusion) => {
            url +=
              (url.includes('?') ? '&' : '?') +
              `occupancy_source_exclusion=${exclusion}`;
          });
        }

        return { url };
      },
      providesTags: ['OccupancyPrediction'],
    }),

    // postResetPredictiveHeatControl: builder.mutation({
    //   query: ({ jobSubscriptionIds }) => ({
    //       url: `/reset_heat_control`,
    //       method: 'POST',
    //       body: JSON.stringify(jobSubscriptionIds)
    //   }),
    //   invalidatesTags: ['PredictiveHeatControl']
    // }),

    postResetPredictiveHeatControl: builder.mutation({
      query: (ids) => ({
        url: '/reset_heat_control',
        method: 'POST',
        body: ids, // don't stringify; fetchBaseQuery will JSON it + set headers
      }),
      invalidatesTags: ['PredictiveHeatControl'],
    }),

    getActuatorPlan: builder.query({
      query: ({ id }) => {
        const url = `/actuator_plan/${id}`;
        if (!id || isNaN(id)) {
          throw new Error('Invalid ID received');
        }
        return { url };
      },
      providesTags: ['ActuatorPlan'],
    }),

    getActuatorPlanByPeriod: builder.query({
      query: ({ id, start_time, end_time }) => {
        // Validate ID
        if (!id || isNaN(id)) {
          throw new Error('Invalid ID received');
        }

        // Construct query parameters for start_time and end_time
        const params = new URLSearchParams();
        if (start_time) {
          params.append('start_time', start_time);
        }
        if (end_time) {
          params.append('end_time', end_time);
        }

        // Construct the URL with query parameters
        const url = `/actuator_plan/${id}?${params.toString()}`;

        return { url };
      },
      providesTags: ['ActuatorPlan'],
    }),

    updateMachineLearningModel: builder.mutation({
      query: ({ id, data }) => ({
        url: `/reset_machine_learning/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['MachineLearningModel'],
    }),
  }),
});

export const {
  useGetOccupancyPredictionQuery,
  useLazyGetOccupancyPredictionQuery,
  usePostResetPredictiveHeatControlMutation,
  useGetOccupancyPredictionAnalysisQuery,
  useLazyGetOccupancyPredictionAnalysisQuery,
  useUpdateMachineLearningModelMutation,
  useGetActuatorPlanQuery,
  useGetActuatorPlanByPeriodQuery,
  useLazyGetActuatorPlanByPeriodQuery,
} = stateCodeApiSlice;
